export const changeWorkspaces = (payload) => ({
  type: 'INFR_CHANGE_WORKSPACES',
  workspaces: payload
});

/* istanbul ignore next */
export const getWorkspaces = () => ({
  type: 'INFR_GET_WORKSPACES'
});

/* istanbul ignore next */
export const updateWorkspaces = (update) => ({
  type: 'INFR_UPDATE_WORKSPACES',
  update
});
